import {MacOSCursor} from '@remotion/mac-cursors';
import {Video} from '@remotion/media';
import {AbsoluteFill, Easing, interpolate, useCurrentFrame} from 'remotion';

export const TransitionsRecordingComposition = () => {
	const frame = useCurrentFrame();

	return (
		<AbsoluteFill
			name="Canvas Capture"
			durationInFrames={263}
			style={{
				width: 1918,
				height: 1440,
			}}
		>
			<Video
				src={
					'https://remotion.media/explore-remotion/transitions-source-2026-10-20-4654f8f5db5b.mp4'
				}
				durationInFrames={263}
				style={{
					position: 'absolute',
				}}
			/>
			<MacOSCursor
				cursor={interpolate(
					frame,
					[8, 9, 49, 52, 237, 239, 241],
					['auto', 'pointer', 'auto', 'pointer', 'auto', 'pointer', 'auto'],
					{
						easing: Easing.step1,
						extrapolateLeft: 'clamp',
						extrapolateRight: 'clamp',
					},
				)}
				style={{
					position: 'absolute',
					left: 0,
					top: 0,
					scale: interpolate(
						frame,
						[0, 255, 261],
						[6.846190989117112, 6.1615718902054, 6.846190989117112],
						{
							easing: Easing.step1,
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
					translate: interpolate(
						frame,
						[
							8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24,
							25, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56,
							57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72,
							73, 74, 75, 76, 78, 79, 80, 81, 82, 83, 223, 224, 225, 226, 227,
							228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240,
							241, 242, 243, 244, 245, 248, 249,
						],
						[
							'446.0453887011106px 3197.14444898414px',
							'572.0580915945474px 3121.5154329012366px',
							'708.3133380381087px 3026.1233889239684px',
							'874.9752999294284px 2881.577833079523px',
							'1336.8792482264234px 2437.3242209263453px',
							'1516.85919102626px 2270.902945436987px',
							'1738.5046242989265px 2056.7455335586674px',
							'1853.2318092337407px 1941.9648627567508px',
							'1905.701444861271px 1889.4417412621178px',
							'1905.701444861271px 1889.4417412621178px',
							'1939.076625933217px 1856.0130743230695px',
							'1953.4375812502321px 1834.351298146566px',
							'1960.6046874419642px 1819.9101140288972px',
							'1960.6046874419642px 1810.0687144820413px',
							'1960.6046874419642px 1795.6275303643724px',
							'1963.1987519964343px 1790.3859153883297px',
							'1963.1987519964343px 1787.7651079003083px',
							'1965.3381866805335px 1783.4327526650077px',
							'1965.3381866805335px 1783.4327526650077px',
							'1965.3381866805335px 1781.7479478512796px',
							'1961.7278906511162px 1774.5273557924452px',
							'1923.6994391412547px 1727.3528210080601px',
							'1906.9851056717305px 1710.6384875385359px',
							'1873.5564387326822px 1677.2098205994873px',
							'1827.612078891654px 1631.2654607584593px',
							'1791.2149463284181px 1588.2895665416188px',
							'1748.2390521115774px 1551.8924339783828px',
							'1711.8419195483416px 1508.9165397615423px',
							'1668.8660253315009px 1472.5194071983062px',
							'1632.468892768265px 1429.5435129814657px',
							'1569.8101994577128px 1360.3060580173087px',
							'1533.4130668944767px 1317.330163800468px',
							'1487.4687070534487px 1258.2550235857816px',
							'1456.6341046688706px 1209.7165991902834px',
							'1425.7995022842922px 1161.178174794785px',
							'1397.9333655239016px 1122.186977677079px',
							'1379.5877131077518px 1094.6952419864056px',
							'1353.7005534301527px 1064.2350406715448px',
							'1329.765627901794px 1040.300115143186px',
							'1320.5928016937191px 1026.5542472978493px',
							'1290.1326003788581px 1000.6670876202503px',
							'1242.958065594473px 958.065594473127px',
							'1219.0231400661144px 934.1306689447684px',
							'1198.0566801619434px 917.737250677859px',
							'1178.0529658656167px 889.5501987148534px',
							'1170.8323738067822px 882.329606656019px',
							'1160.0014857185306px 871.4987185677674px',
							'1156.3911896891134px 861.6573190209115px',
							'1150.1600861716747px 851.8159194740556px',
							'1147.5392786836535px 846.5743044980129px',
							'1144.918471195632px 843.9534970099915px',
							'1144.918471195632px 841.7873193923411px',
							'1142.9394941128403px 839.1665119043197px',
							'1142.9394941128403px 839.1665119043197px',
							'1140.3186866248188px 827.426364075326px',
							'1134.0875831073804px 817.5849645284701px',
							'1131.466775619359px 812.3433495524273px',
							'1128.8459681313375px 807.1017345763845px',
							'1126.225160643316px 801.8601196003417px',
							'1126.225160643316px 801.8601196003417px',
							'1126.225160643316px 805.1495004271441px',
							'1126.225160643316px 851.6554618727482px',
							'1126.225160643316px 896.9847342420978px',
							'1126.225160643316px 1002.191434832671px',
							'1099.5357129591798px 1138.553653010437px',
							'1061.239832113806px 1291.5232329235225px',
							'997.8055937302678px 1481.7724622070348px',
							'923.781153660439px 1672.021691490547px',
							'849.7567135906103px 1862.2709207740593px',
							'749.4974557070163px 2061.639490398544px',
							'660.84463098466px 2272.6144931842664px',
							'565.6665304758013px 2452.3002637150394px',
							'494.66404189726256px 2623.909668313338px',
							'430.7216877762508px 2760.2718864911044px',
							'392.4525498644282px 2836.756676447647px',
							'341.50726144931843px 2964.213497752851px',
							'311.2342606693162px 3054.87204249155px',
							'284.9726999219998px 3120.445715559187px',
							'273.794153697582px 3164.9459569884484px',
							'264.59458455595586px 3192.3842068120193px',
							'264.59458455595586px 3202.172120491773px',
							'261.97377706793446px 3209.9543141551835px',
							'261.97377706793446px 3209.9543141551835px',
							'261.97377706793446px 3211.719347769565px',
						],
						{
							extrapolateLeft: 'clamp',
							extrapolateRight: 'clamp',
						},
					),
				}}
			/>
		</AbsoluteFill>
	);
};
